import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Tag, Text,
} from 'idsk-react-components';
import './terminTableMobileItem.scss';
import routes from '../../../../../../routing/routes';

interface Props {
  termin: string,
  stavPublikacie: boolean,
  uuid: string,
  terminUuid:string,
  actions: ReactElement,
}

const TerminTableMobileItem = ({
  termin,
  stavPublikacie,
  uuid,
  terminUuid,
  actions,
}: Props): ReactElement => (
  <Col className="termin-table-mobile-item-row">
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">Termín</Text>
      </div>
      <div className="two-thirds">
        <Link to={routes.tezaurus.admin.termin.detail.withParams(uuid, terminUuid)}>
          {termin}
        </Link>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">Stav publikácie</Text>
      </div>
      <div className="two-thirds">
        {stavPublikacie ? (
          <Tag className="m-l-10" size="medium" type="primary">publikované</Tag>
        ) : (
          <Tag className="m-l-10" size="medium" type="danger">nepublikované</Tag>
        )}
      </div>
    </Row>
    <Row className="dokument-detail-row">
      {actions}
    </Row>
  </Col>
);

export default TerminTableMobileItem;
